import useGetActorSummary from "../../../hooks/useGetActorSummary";
import { RLCard } from "../../../../../components";
import { Link } from "../../../../../components/link";
import { ActorSourcesProps } from "../../../@types/actor";
import styles from "../ioc.module.scss";

const ActorSources = ({ actorName, sources }: ActorSourcesProps) => {
  const { data: actorData } = useGetActorSummary(
    !sources ? actorName || "" : ""
  );
  const actorSources = sources || actorData?.sources || [];
  return (
    <RLCard
      header={
        <RLCard.Header>
          <span>Sources</span>
        </RLCard.Header>
      }
      content={
        <RLCard.Content>
          {actorSources.length > 0 ? (
            <div className={styles.ioc_key_value_entry}>
              {actorSources.map(source => (
                <div key={source}>
                  <Link href={source} target="_blank">
                    {source}
                  </Link>
                </div>
              ))}
            </div>
          ) : (
            <div>No sources available for this actor.</div>
          )}
        </RLCard.Content>
      }
    />
  );
};

export default ActorSources;
